<div class="loading-overlay">
  <div class="loading-content">
    <div class="loading-title">Loading</div>
    <div class="loading-bar-track">
      <div class="loading-bar-fill" [style.width.%]="progress.overallProgress * 100"></div>
    </div>
    <div class="loading-stage">{{ progress.stage }}</div>
    @if (progress.detail) {
      <div class="loading-detail">{{ progress.detail }}</div>
    }
  </div>
</div>
